export function formatPhoneNumber(phoneNumber) {

    const cleaned = phoneNumber?.replace(/\D/g, '');

    let formatted = cleaned;
    if (cleaned?.length > 3 && cleaned?.length <= 6) {
        formatted = `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
    } else if (cleaned?.length > 6 && cleaned?.length <= 10) {
        formatted = `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    } else if (cleaned?.length > 10) {
        formatted = `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}${cleaned.slice(10)}`;
    }

    return formatted;
}


export function isMobile() {
    return window.innerWidth <= 800;
}


export function matchCartItemsToBundles(cartItems = [], bundleItems = []) {
    let appliedBundles = [];
    let remainingItems = [];
    let breakBundleData = []
    let cartSkuId = cartItems.map(i => i?.sku_id)
    for (const bundleItem of bundleItems) {
        const bundleProductData = bundleItem?.bundleProduct
        const bundleSkuIds = bundleProductData.map(i => i?.sku?.sku_id)
        const allExist = bundleSkuIds.every(item => cartSkuId.includes(item));
        if (allExist) {
            const productArr = []
            for(const bundleProduct of bundleProductData)
            {
                const cartItemDetails = cartItems.find(n => n.sku_id == bundleProduct?.sku?.sku_id)
                productArr.push({
                    ...cartItemDetails,
                    ratio_price : bundleProduct?.ratio_price
                })
            }
            appliedBundles.push({
                ...bundleItem,
                productArr : productArr
            })
            bundleSkuIds.forEach(item => {
                const index = cartSkuId.indexOf(item);
                if (index > -1) {
                    cartSkuId.splice(index, 1);
                }
            });
        }
    }
    for (const skuId of cartSkuId) {
        const findCartItem = cartItems.find(n => n.sku_id == skuId)
        if (findCartItem) {
            remainingItems.push(findCartItem)
        }

    }
    if (appliedBundles.length > 0) {
        for (const appliedBundle of appliedBundles) {
            const appliedBundleProductData = appliedBundle?.bundleProduct
            const arr = []
            for (const appliedBundleProduct of appliedBundleProductData) {
                const appliedBundleProductSku = appliedBundleProduct?.sku?.sku_id
                const appliedBundleProductQuantity = appliedBundleProduct?.bundle_quantity
                const cartItemDetails = cartItems.find(n => n.sku_id == appliedBundleProductSku)
                const cartItemQuantity = cartItemDetails?.quantity
                const updatedQuantity = parseInt(cartItemQuantity) - parseInt(appliedBundleProductQuantity)
                if (updatedQuantity >= 0) {
                    arr.push({
                        ...appliedBundleProduct,
                        cartItemDetails: cartItemDetails,
                        appliedBundleProductQuantity: appliedBundleProductQuantity,
                        quantity: updatedQuantity,
                        cartItemQuantity: cartItemQuantity
                    })
                }
                else if (updatedQuantity < 0) {
                    breakBundleData = appliedBundles.filter(n => n?.bundle_id == appliedBundle?.bundle_id)
                    appliedBundles = appliedBundles.filter(n => n?.bundle_id !== appliedBundle?.bundle_id)
                }
            }
            if (arr.length > 0) {
                const values = []
                const remainValue = []
                for (const arrData of arr) {
                    remainValue.push({
                        ...arrData,
                        remainValueResult: parseInt(arrData?.cartItemQuantity) % parseInt(arrData?.appliedBundleProductQuantity)
                    })
                    const quaValue = parseInt(arrData?.cartItemQuantity) / parseInt(arrData?.appliedBundleProductQuantity)
                    let result = Math.trunc(quaValue);
                    values.push(result)
                }
                if (values.length > 0) {
                    const allSame = values.every(value => value === values[0]);
                    if (allSame) {
                        appliedBundles = appliedBundles.map(n => {
                            if (n.bundle_id == appliedBundle.bundle_id) {
                                return {
                                    ...n,
                                    quantity: values[0],
                                }
                            }
                            else {
                                return {
                                    ...n,
                                    quantity: n?.quantity || 1
                                }
                            }
                        })
                        for (const remain of remainValue) {
                            if (remain.remainValueResult > 0) {
                                remainingItems.push({
                                    ...remain.cartItemDetails,
                                    quantity: remain.remainValueResult
                                })
                            }
                        }
                    }
                    else {
                        appliedBundles = appliedBundles.map(n => {
                            return {
                                ...n,
                                quantity: Math.min(...values) || 1
                            }
                        })
                        for (const remain of remainValue) {
                            if (remain.remainValueResult > 0) {
                                remainingItems.push({
                                    ...remain.cartItemDetails,
                                    quantity: remain.quantity - Math.min(...values) 
                                })
                            }
                            else {
                                const quantityData = remain?.cartItemQuantity % Math.min(...values)
                                if (quantityData > 0) {
                                    remainingItems.push({
                                        ...remain.cartItemDetails,
                                        quantity: quantityData
                                    })
                                }
                                else {
                                    const quantityData = remain?.cartItemQuantity/remain.appliedBundleProductQuantity
                                    if (quantityData > 1 && quantityData - Math.min(...values) !== 0) {
                                        remainingItems.push({
                                            ...remain.cartItemDetails,
                                            quantity: remain.quantity - Math.min(...values)
                                        })
                                    }
                                    else
                                    {
                                        if(quantityData - Math.min(...values) !== 0)
                                        {
                                            remainingItems.push({
                                                ...remain.cartItemDetails,
                                                quantity: remain.quantity
                                            })
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    for (const arrData of arr) {
                        remainingItems.push({
                            ...arrData.cartItemDetails,
                            quantity: arrData.quantity
                        })
                    }
                }
            }
        }
    }
    if (breakBundleData.length > 0) {
        for (const breakBundle of breakBundleData) {
            const breakBundleProductData = breakBundle?.bundleProduct
            for (const breakBundleProduct of breakBundleProductData) {
                const breakBundleProductProductSku = breakBundleProduct?.sku?.sku_id
                const cartItemDetails = cartItems.find(n => n.sku_id == breakBundleProductProductSku)
                remainingItems = remainingItems.filter(n => n.sku_id !== breakBundleProductProductSku)
                remainingItems.push({
                    ...cartItemDetails,
                })
            }
        }
    }
    return {
        appliedBundles,
        remainingItems
    };
}

// export function matchCartItemsToBundles(cartItems = [], bundleItems = []) {
//     let appliedBundles = [];
//     let remainingItems = [];
//     let cartSkuId = cartItems.map(item => item?.sku_id);

//     for (const bundleItem of bundleItems) {
//         const bundleProductData = bundleItem?.bundleProduct;
//         const bundleSkuIds = bundleProductData.map(product => product?.sku?.sku_id);

//         if (bundleSkuIds.every(skuId => cartSkuId.includes(skuId))) {
//             appliedBundles.push({ ...bundleItem });
//             cartSkuId = cartSkuId.filter(skuId => !bundleSkuIds.includes(skuId));
//         }
//     }

//     cartSkuId.forEach(skuId => {
//         const item = cartItems.find(cartItem => cartItem.sku_id === skuId);
//         if (item) remainingItems.push({ ...item });
//     });

//     appliedBundles = appliedBundles.map(bundle => {
//         const updatedBundleProducts = [];
//         let validBundle = true;

//         for (const product of bundle.bundleProduct) {
//             const skuId = product?.sku?.sku_id;
//             const bundleQuantity = product?.bundle_quantity;
//             const cartItem = cartItems.find(item => item.sku_id === skuId);

//             if (!cartItem || cartItem.quantity < bundleQuantity) {
//                 validBundle = false;
//                 break;
//             }

//             const remainingQuantity = cartItem.quantity - bundleQuantity;
//             updatedBundleProducts.push({
//                 ...product,
//                 cartItemDetails: { ...cartItem },
//                 appliedBundleProductQuantity: bundleQuantity,
//                 remainingQuantity,
//             });
//         }

//         if (validBundle) {
//             const bundleQuantities = updatedBundleProducts.map(product => 
//                 Math.floor(product.cartItemDetails.quantity / product.appliedBundleProductQuantity)
//             );
//             const bundleQuantity = Math.min(...bundleQuantities);

//             const updatedBundle = { ...bundle, quantity: bundleQuantity };

//             updatedBundleProducts.forEach(product => {
//                 const remainder = product.cartItemDetails.quantity % product.appliedBundleProductQuantity;
//                 if (remainder > 0) {
//                     remainingItems.push({
//                         ...product.cartItemDetails,
//                         quantity: remainder,
//                     });
//                 }
//             });

//             return updatedBundle;
//         } else {
//             remainingItems.push(
//                 ...bundle.bundleProduct.map(product => {
//                     const cartItem = cartItems.find(item => item.sku_id === product?.sku?.sku_id);
//                     return cartItem ? { ...cartItem } : null;
//                 }).filter(Boolean)
//             );
//             return null;
//         }
//     }).filter(Boolean);

//     return {
//         appliedBundles,
//         remainingItems,
//     };
// }
